import { computed, defineComponent, useCssModule, useRoute } from '@nuxtjs/composition-api';
import { useArchive } from '~/composables';
export default defineComponent({
    name: 'CardArchive',
    setup() {
        /**
         * Composables.
         */
        const archive = useArchive();
        const css = useCssModule();
        const route = useRoute();
        const to = computed(() => {
            const { params: { rubric = '' }, } = route.value;
            const archivePath = rubric?.replace(/\/$/, '') || '';
            return archive.hasPath(archivePath) ? `/archive/${archivePath}` : '/archive';
        });
        return {
            css,
            to,
        };
    },
});
